import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
const commomPaths = [
  {
    name: "Loader",
    meta: "借款人信息"
  },
  {
    name: "CaculateQuota",
    meta: "额度测算"
  },
  {
    name: "CaculateQuotaInterval",
    meta: "额度测算"
  },
  {
    name: "IdenfityTesting",
    meta: "资格评估"
  },
  {
    name: "PrecreditFailure",
    meta: "预授信失败"
  },
  {
    name: "PrecreditSuccess",
    meta: "预授信成功"
  },
  {
    name: "IdentifyCardUpload",
    meta: "上传证件"
  },
  {
    name: "BusinessLicenseUpload",
    meta: "上传营业执照"
  },
  {
    name: "AccessSuccess",
    meta: "预授信成功"
  },
  {
    name: "testing",
    meta: "预授信中"
  },
  {
    name: "testingInterval", // 预授信中连续调用接口
    meta: "预授信中"
  },
  {
    name: "FailureAccess",
    meta: "初审失败"
  },
  {
    name: "FirstTrialSuccess",
    meta: "初审成功"
  },
  {
    name: "microEnterpriseLoan",
    meta: "微业贷申请"
  },
  {
    name: "CreditFailure",
    meta: "授信失败"
  },
  {
    name: "GiveTrust",
    meta: "授信成功"
  },
  {
    name: "IdentifySuccess",
    meta: "身份验证成功"
  },
  {
    name: "BusinessLicenseSuccess",
    meta: "营业执照上传成功"
  },
  {
    name: "DrawingMoney",
    meta: "提款中"
  },
  {
    name: "DrawingMoneyReview",
    meta: "支用审批中"
  },
  {
    name: "grantLoaning",
    meta: "放款中"
  },
  {
    name: "grantLoaningNew",
    meta: "放款中"
  },
  {
    name: 'withdrawalFailed',
    meta: '支用申请失败',
  },
  {
    name: 'signingSecurityContract',
    meta: '签署担保合同',
  },
  {
    name: "UnableAccess",
    meta: "无法评估"
  },
  {
    name: "IdentifyUploadSuccess",
    meta: "身份上传成功"
  },
  {
    name: "IdentifyUploadFailure",
    meta: "身份上传失败"
  },
  {
    name: "identityAuthentication",
    meta: "上传证件"
  },
  {
    name: "LipCheck",
    meta: "人脸识别"
  },
  {
    name: "Lipcheck_success",
    meta: "人脸识别验证成功"
  },
  {
    name: "PufaAccessSuccess", // 6
    meta: "预授信成功"
  },
  {
    name: "linkFailure", // 6
    meta: "小望数科"
  },
  {
    name: "nuclearElectricity", // 6
    meta: "电核中"
  },
  {
    name: "electricalEnergySuccess", // 6
    meta: "电核成功"
  },
  {
    name: "electricalEnergyFailure", // 6
    meta: "电核失败"
  },
  {
    name: "bankCardBinding", 
    meta: "银行卡绑定" //百商贷聚合产品
  },
  {
    name: "bankCardBindingTwice", 
    meta: "银行卡再次绑定" //百商贷聚合产品
  },
  {
    name: "applicationCompleted",
    meta: "申请提交完成" //百商贷聚合产品
  },
  {
    name: "idCardRecognition",
    meta: "上传证件" //百商贷聚合产品
  },
  {
    name: "bankCardSuccess",
    meta: "绑卡成功" //百商贷聚合产品
  },

];
const pufaAlonePaths = [
  {
    name: 'fillCardNumber',
    meta: '银行账号',
  },
  {
    name: 'signContract',
    meta: '签署授信合同',
  },
  // 浦发的提款申请
  {
    name: 'withdrawalRequest',
    meta: '支用申请',
  },
  // 浦发的签署借款合同
  {
    name: 'signLoanContract',
    meta: '签署借款合同',
  },
  {
    name: 'withdrawalSuccessful',
    meta: '放款成功',
  },
  {
    name: 'complianceLipChaeck',
    meta: '人脸识别',
  },
  {
    name: 'authorizationAgreement',
    meta: '征信授权书签署',
  },
  {
    name: 'successfulCreditExtension',
    meta: '征信授权书签署成功',
  },
  {
    name: 'calculationRepayment',
    meta: '提前还款',
  },
  {
    name: 'repaymentSuccessful',
    meta: '还款成功',
  },
  {
    name: 'pufaLipCheck',
    meta: '人脸识别',
  }, {
    name: 'test',
    meta: 'test',
  },
]
const standardPaths = [
  {
    name: 'postLoanPurposeUpload',
    meta: '贷后用途上传'
  },
  // 苏宁的签署授信合同
  {
    name: 'signContractStandard',
    meta: '签署授信合同',
  },
  // 标准化 签署借款合同
  {
    name: 'signLoanContractStandard',
    meta: '签署借款合同',
  },
  {
    name: 'calculationRepaymentStandard',
    meta: '提前还款',
  },
  {
    name: 'calculationRepaymentNew',
    meta: '提前还款',
  },
  // 苏宁的提款申请
  {
    name: 'withdrawalRequestStandard',
    meta: '提款申请',
  },
  // 亿联的提款申请
  {
    name: 'withdrawalRequestYiLian',
    meta: '支用申请',
  },
  {
    name: 'withdrawalSuccessfulStandard',
    meta: '放款成功',
  },
  {
    name: 'withdrawalFailedStandard',
    meta: '支用失败',
  },
  {
    name: 'repaymentSuccessfulStandard',
    meta: '还款成功',
  },
  // 签署担保合同变成可配置json
  {
    name: 'signingSecurityContractStandard',
    meta: '签署担保合同',
  },
  // 亿联-支付担保费
  {
    name: 'yilianSecurityContractStandard',
    meta: '支付担保费',
  },
  {
    name: 'loanInfoExplain',
    meta: '贷款信息说明',
  },
  {
    name: "BusinessLicenseUploadStandard",
    meta: "上传营业执照"
  },
  {
    name: 'withdrawalRequestNew',
    meta: '支用申请', //百商贷聚合产品
  },
]
const openAccountPaths = [
  {
    name: 'UploadIdentity',
    meta: 'Ⅱ类电子账户开户',
  },
  {
    name: 'OpenAccountApply',
    meta: 'Ⅱ类电子账户开户',
  },
  {
    name: 'OpenAccountSuccess',
    meta: 'Ⅱ类电子账户开户',
  },
  {
    name: 'Capitalaccount',
    meta: '资金账户',
  },
  {
    name: 'ChangeCardNumber',
    meta: '变更还款卡号',
  },
  {
    name: 'ToIntoing',
    meta: '转出中',
  },
  {
    name: 'ToIntoingIn',
    meta: '转入中',
  },
  {
    name: 'ToIntoFail',
    meta: '转入失败',
  },
  {
    name: 'ToIntoSuccess',
    meta: '转出成功',
  },
  {
    name: 'ToIntoSuccessIn',
    meta: '转入成功',
  },
  {
    name: 'DetailedfulTransfer',
    meta: '转入明细',
  },
  {
    name: 'DetailedTransferOut',
    meta: '转出明细',
  },
  {
    name: 'EnterAmount',
    meta: '资金转入',
  },
  {
    name: 'OutAmount',
    meta: '资金转出',
  },
  {
    name: 'TransactionRecord',
    meta: '交易记录',
  },
  {
    name: 'BindCardManage',
    meta: '||类电子账户绑卡管理',
  },
  {
    name: 'BindCard',
    meta: '||类电子账户绑定银行卡',
  },
  {
    name: 'UnbundCard',
    meta: '||类电子账户解绑银行卡',
  },
  {
    name: 'template',
    meta: 'test',
  },
]
const publicPagePaths = [
  {
    name: "myload",
    meta: "申请记录"
  },
  {
    name: "aggsLoadList",
    meta: "初审完成"
  },
  {
    name: "loanSupermarket",
    meta: "推荐产品"
  },
  {
    name: "loanScheme",
    meta: "贷款方案"
  },
  {
    name: "selectProvince",
    meta: "定位"
  },
  {
    name: "newPeople",
    meta: "新手指引"
  },
  {
    name: "checkAmount",
    meta: "查看额度"
  },
  {
    name: "loanAmount",
    meta: "查看额度"
  },
  {
    name: "reimbursementMiscalculation",
    meta: "还款试算"
  },
  {
    name: "login",
    meta: "快捷登录/注册"
  },
  {
    name: "register",
    meta: "注册"
  },
  {
    name: "resetPassword",
    meta: "密码重置"
  },
  {
    name: "repaymentPlan",
    meta: "还款详情"
  },
  {
    name: "productDetail",
    meta: "产品详情"
  },
  {
    name: "realName",
    meta: "实名认证"
  },
  {
    name: "personalCenter",
    meta: "个人中心"
  },
  {
    name: "bindEnterprise",
    meta: "企业管理"
  },
  {
    name: "realNameAuth",
    meta: "实名认证"
  },
  {
    name: "bindingEnterprise",
    meta: "绑定企业"
  },
  {
    name: "accessFailed",
    meta: "404"
  },
  {
    name: "CommonFailPage",
    meta: "" //统一错误页面
  },
  {
    name: "transferPage",
    meta: "" //中转页
  },
  
  {
    name: "Perfect",
    meta: "进件信息填写"
  },
  {
    name: "PerfectUnite",
    meta: "进件信息填写"//联合登录
  },
  {
    name: "perfectdemo",
    meta: "进件信息填写"
  },
  {
    name: "myContract",
    meta: "我的合同"
  },
  {
    name: "contractDetail",
    meta: "协议详情"
  },
  {
    name: "scanCode",
    meta: "二维码"
  },
  {
    name: "scanCodeOut",
    meta: "" //二维码跳出
  },
  {
    name: "scanCodeWZApp",
    meta: "APP扫码"
  },
  
  {
    name: "soloPage",
    meta: "新增二维码"
  },
  {
    name: 'posters',
    meta: '通知'
  },
  {
    name: 'supplementaryInformation',
    meta: '补充资料'
  },
  {
    name: "dataAcquisition", // 数据采集页面
    meta: "数据上传"
  },
  {
    name: 'taxEmpower',
    meta: '税务数据授权'
  },
  { // 企业
    name: 'taxEmpowerEnterprise',
    meta: '税务数据授权'
  },
  {
    name: 'coreEnterprise', // 核心企业选择
    meta: '核心企业'
  },
  {
    name: 'faceRecognitionPre', // 人脸识别页面前置
    meta: '人脸识别'
  },
  {
    name: 'faceRecognition', // 新人脸识别
    meta: '人脸识别'
  },
  {
    name: 'faceRecognitionV2', // 新人脸识别2.0
    meta: '人脸识别'
  },
  {
    name: 'faceRecognitionV3', // 订单外人脸识别
    meta: '人脸识别'
  },
  {
    name: 'accountManage',
    meta: '账号与安全'
  }, 
  {
    name: "officialAccountImg",
    meta: "",
  },
];
const intelligentMatchingPath = [
  {
    name: "intelligentMatching",
    meta: "智能匹配"
  },
  {
    name: 'maching',
    meta: '系统匹配中'
  }, {
    name: 'UnableEvaluate',
    meta: '无法评估'
  }, {
    name: 'noMatchInfo',
    meta: '暂无匹配信息'
  }, {
    name: 'matchSuccessful',
    meta: '匹配结果'
  }
];
const uploadTicket = [
  {
    name: "uploadTicket",
    meta: "上传进项发票"
  },
  {
    name: 'manualEntry',
    meta: '手工录入'
  },
  {
    name: 'upoladSuccess',
    meta: '上传成功',
  },
  {
    name: 'upoladFail',
    meta: '上传失败'
  }
]
// 解析路由
const compiler = (paths, fileName) =>
  paths.map((val) => {
    const path = val.name !== "loanSupermarket" ? val.name : '';
    return {
      path: `/supermarket/v2/${path}`,
      name: val.name,
      // component: () => Promise.resolve(require('@/views/pages/master-baffle/index').default),
      component: () => Promise.resolve(require(`@/views/pages/${fileName}/${val.name}`).default),
      meta: {
        title: val.meta,
        content: val.name === "upoladSuccess"
      },

    }
  })
const commomPathsArr = compiler(commomPaths, 'commonPage') // 公共路由数组
const pufaaloneArr = compiler(pufaAlonePaths, 'otherPage') // 浦发独有路由数组
const standardArr = compiler(standardPaths, 'standardPage') // 苏宁标准化路由数组
const openAccountArr = compiler(openAccountPaths, 'openAccount') // 开户流程路由
const publicPageArr = compiler(publicPagePaths, 'publicPage') // 开户流程路由
const matchArr = compiler(intelligentMatchingPath, 'intelligentMatchPage')
const invoiceCheck = compiler(uploadTicket, 'invoiceCheck') // 发票核验
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/supermarket/v2/calculation',
      name: 'test',
      component: () =>
        import(
          /* webpackChunkName: "calculation" */
          './views/calculation/calculation.vue'
        ),
      meta: {
        title: '客户咨询',
      },
    },
  ].concat(commomPathsArr, pufaaloneArr, standardArr, openAccountArr, publicPageArr, matchArr, invoiceCheck),
})
